import { Box, Button, Card, Divider, Typography } from '@mui/material';
import React, { useState } from 'react';
import DialogHistorialEmpaque from './DialogHistorialEmpaque';

function HistorialSection({ data }) {
  const [openDialog, setOpenDialog] = useState(false);
  return (
    <Card sx={{ padding: '15px', textAlign: 'center', marginTop: '15px' }}>
      <Typography>Historial de empaques</Typography>
      <Divider />
      <Box sx={{ marginTop: '15px', padding: '15px', display: 'flex', justifyContent: 'center' }}>
        <Button variant="contained" color="info" onClick={() => setOpenDialog(true)}>
          ver historial de empaque
        </Button>
        <DialogHistorialEmpaque open={openDialog} onClose={setOpenDialog} dataUser={data} />
      </Box>
    </Card>
  );
}

export default HistorialSection;
